import * as actionType from "./ActionTypes";
import { findIndex } from "lodash";

export default function DailyPlanEmailReducer(state = {}, action) {
  const { payload } = action;
  switch (action.type) {
    case actionType.DAILY_PLAN_EMAIL_DATA:
      return (state = payload);
    case actionType.UPDATE_DAILY_PLAN_EMAIL:
      for (let i = 0; i < payload.emailData.length; i++) {
        const findId = findIndex(
          state[payload.emailData[i]["Transporter"]]["subRows"],
          (data) => {
            return (
              data.DailyContainerPlanningID.toString() ===
              payload.emailData[i].DailyContainerPlanningID.toString()
            );
          }
        );
        state[payload.emailData[i]["Transporter"]]["subRows"][findId] = {
          ...payload.emailData[i],
          isMailSentToFactory:
            state[payload.emailData[i]["Transporter"]]["subRows"][findId]
              .isMailSentToFactory === 1
              ? 1
              : payload.isMailSentToFactory === true
              ? 1
              : 0,
          isMailSentToJD:
            state[payload.emailData[i]["Transporter"]]["subRows"][findId]
              .isMailSentToJD === 1
              ? 1
              : payload.isMailSentToJD === true
              ? 1
              : 0,
          isMailSentToTransporter:
            state[payload.emailData[i]["Transporter"]]["subRows"][findId]
              .isMailSentToTransporter === 1
              ? 1
              : payload.isMailSentToTransporter === true
              ? 1
              : 0,
        };
      }
      return state;
    default:
      return state;
  }
}
